import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { DARK_INPUT, errMsg } from "../control/shared";

export function PickupSettings() {
  const [s, setS] = useState({ pickup_location: "", pickup_hours: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/worker-mgmt/card-settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/worker-mgmt/card-settings", s); setS(data); toast.success("Pickup details saved"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="admin-card p-4 mt-3" data-testid="wm-pickup-settings">
      <div className="flex items-center gap-2 font-bold text-sm"><MapPin size={15} className="text-orange-400"/>Card pickup details</div>
      <p className="text-xs text-slate-500 mt-1">Sent to the worker when a card is marked printed, then as a reminder every 3 days (up to 2 times) until it is marked issued.</p>
      <div className="flex flex-col md:flex-row gap-2 mt-3">
        <Input value={s.pickup_location} onChange={(e) => setS({ ...s, pickup_location: e.target.value })} placeholder="Pickup address, e.g. Karmivo Office, Malviya Nagar, Jaipur" className={`${DARK_INPUT} h-9 flex-[2]`} data-testid="wm-pickup-location"/>
        <Input value={s.pickup_hours} onChange={(e) => setS({ ...s, pickup_hours: e.target.value })} placeholder="Timings, e.g. Mon-Sat 10am-6pm" className={`${DARK_INPUT} h-9 flex-1`} data-testid="wm-pickup-hours"/>
        <Button size="sm" className="bg-orange-500 hover:bg-orange-600 h-9" disabled={busy} onClick={save} data-testid="wm-pickup-save">Save</Button>
      </div>
      {!s.pickup_location && <p className="text-xs text-amber-300 mt-2" data-testid="wm-pickup-empty">No address set: workers will be told to call support (9636873585) to arrange pickup.</p>}
    </div>
  );
}
